export default __webpack_public_path__ + "static/media/peleando.1b6ccf4b.png";